import { render, staticRenderFns } from "./WrongStudy.vue?vue&type=template&id=45164f1c&"
import script from "./WrongStudy.vue?vue&type=script&lang=js&"
export * from "./WrongStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports